import { cn } from "../lib/utils.js";

interface SparklineProps {
	data: number[];
	color?: string;
	className?: string;
}

export function Sparkline({
	data,
	color = "var(--color-secondary)",
	className,
}: SparklineProps) {
	if (data.length < 2) return null;

	const W = 100;
	const H = 40;
	const max = Math.max(...data);
	const min = Math.min(...data);
	const range = max - min || 1;

	const pts = data.map(
		(v, i) =>
			[(i / (data.length - 1)) * W, H - ((v - min) / range) * (H - 6) - 3] as [
				number,
				number,
			],
	);

	const line = pts
		.map(
			(p, i) => `${i === 0 ? "M" : "L"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`,
		)
		.join(" ");
	const area = `${line} L${W} ${H} L0 ${H} Z`;

	return (
		<svg
			viewBox={`0 0 ${W} ${H}`}
			className={cn("pointer-events-none", className)}
			preserveAspectRatio="none"
			aria-hidden
			role="img"
		>
			<title>Trend sparkline</title>
			<path d={area} fill={color} opacity="0.12" />
			<path d={line} fill="none" stroke={color} strokeWidth="1.5" />
		</svg>
	);
}
